<script setup lang="ts">
import MainLayout from "views/layouts/MainLayout.vue";
import BlockWhite from "components/BlocksCustom/BlockWhite.vue";
import NewsletterBox from "components/HomePage/NewsletterBox.vue";
import ColunasHome from "components/HomePage/ColunasHome.vue";
import BannerEnsaioGratis from "components/HomePage/BannerEnsaioGratis.vue";
import BannerFreeTour from "components/HomePage/BannerFreeTour.vue";
import CarouselModels from "components/HomePage/CarouselModels.vue";
</script>

<template>
  <MainLayout #="{ showModalMessages }">
    <div class="slot-body">
      <PhotoShooting :card-principal="cardPrincipal" :ultimos-cards="ultimosCards" />
      <BlogBlock :post-blogs="postBlogs" />
      <BlockWhite :styles="WhiteIsMobile()"/>
      <CarouselModels :posts="posts" />      
      <BlogMobile :post-blogs="postBlogs" :path2="bannerFreeTour2"/>
      <BannerEnsaioGratis />
      <ColunasHome :title-visible="true" :button-mobile="true" :button-more="true" />
      <NewsletterBox @showModalMessages="showModalMessages" />
      <BannerFreeTour :path1="bannerFreeTour1" :path2="bannerFreeTour2"/>
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PhotoShooting from "components/HomePage/BannerPhotoShooting.vue";
import BlogBlock from "components/HomePage/BlogBlock.vue";
import BlogMobile from "components/HomePage/BlogMobile.vue";
import { isMobile } from "views/shared/utils/mobile";
import { mapState } from "pinia";
import { localeStore } from "stores/locale";
import api from "../../api";
import ImgFreetour1 from "assets/img/BannerFreeTour1BelladaSemana.webp";
import ImgFreetour1Mobile from "assets/img/BannerFreeTour1BelladaSemana-mobile.webp";
import ImgFreetour2Pt from "assets/img/BannerFreeTour2BelladaSemanaPt.webp";
import ImgFreetour2PtMobile from "assets/img/BannerFreeTour2BelladaSemanaPt-mobile.webp";
import ImgFreetour2En from "assets/img/BannerFreeTour2BelladaSemanaEn.webp";
import ImgFreetour2EnMobile from "assets/img/BannerFreeTour2BelladaSemanaEn-mobile.webp";

export default defineComponent({
  name: "homePage",
  components: {
    PhotoShooting,
    NewsletterBox,
    ColunasHome,
    BannerEnsaioGratis,
  },
  computed: {
    ...mapState(localeStore, ["locale"]),
  },
  watch: {
    locale: function () {
      this.getUltimosCards(true);
      this.getCardPrincipal(true);
      this.getPostsBlog(true);
      this.getPostsBlog(true);
      this.getBannerFreeTour1();
      this.getBannerFreeTour2();
    },
  },
  head() {
    return {
      templateParams: {
        subTitle: this.locale == "en"? '- bellaclub.com': null,
        subPage: null,
        page_url: window.location.origin + this.$route.fullPath,
        page_description:
          this.locale == "pt-br"
            ? `Bella da Semana Sedução, entretenimento, ensaios, fotos e vídeos das mais TOPs e belas modelos brasileiras na maior revista masculina do Brasil`
            : `BellaClub Seduction, entertainment, rehearsals, photos and videos of the most TOPs and beautiful Brazilian models in the largest men\'s magazine in Brazil - bellaclub.com`,
        page_image: this.fixedThumb ?? "/favicon.ico",
        page_keywords:
          "bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site",
        page_locale: this.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br",
        page_url_en: "https://belladasemana.com.br/en",
        page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,        
      },
    };
  },
  data() {
    return {
      ultimosCards: [],
      cardPrincipal: "",
      postBlogs: [],
      bannerAssineHorizontal: [],
      bannerFreeTour1: "",
      bannerFreeTour2: "",
      fixedThumb: "",
      isMobile: isMobile(),
      posts: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.getUltimosCards();
      this.getCardPrincipal();
      this.getPostsBlog();
      this.getBannerFreeTour1();
      this.getBannerFreeTour2();
      this.getLastModels();      
    },
    async getCardPrincipal(changeLanguage = false) {
      if (!sessionStorage.getItem("cardPrincipal") || changeLanguage)
        api
          .get(`v1/home/getEssayPrimary?language=${this.locale}&mobile=${this.isMobile}`)
          .then(({ data }) => {
            this.cardPrincipal = data.cardPincipal;
            this.fixedThumb = data.cardPincipal?.fixedThumb;
            sessionStorage.setItem("cardPrincipal", JSON.stringify(this.cardPrincipal));
          });
      else this.cardPrincipal = JSON.parse(sessionStorage.getItem("cardPrincipal"));
    },
    async getUltimosCards(changeLanguage = false) {
      if (!sessionStorage.getItem("ultimosCards") || changeLanguage)
      api
        .get(`v1/home/getEssaySecondary?language=${this.locale}&mobile=${this.isMobile}`)
        .then(({ data }) => {
          this.ultimosCards = data.ultimosCards;
          sessionStorage.setItem("ultimosCards", JSON.stringify(this.ultimosCards));
        });
        else this.ultimosCards = JSON.parse(sessionStorage.getItem("ultimosCards"));
    },
    async getPostsBlog(changeLanguage = false) {
      // if (!sessionStorage.getItem("postBlogs") || changeLanguage)
      api
        .get(
          `v1/home/getBlogs?language=${this.locale}&limit=${isMobile() ? 6 : 3}&mobile=${
            this.isMobile
          }`
        )
        .then(({ data }) => {
          this.postBlogs = data.blogs;
          // sessionStorage.setItem("postBlogs", JSON.stringify(this.postBlogs));
        });
        // else this.postBlogs = JSON.parse(sessionStorage.getItem("postBlogs"));
    },
    async getBannerFreeTour1() {
      this.bannerFreeTour1 = {
        image: this.isMobile ? ImgFreetour1Mobile : ImgFreetour1,
        url: `${this.locale}/freetour`,
      };
    },
    async getBannerFreeTour2() {
      if (this.locale == "pt-br") {
        this.bannerFreeTour2 = { image: this.isMobile ? ImgFreetour2PtMobile : ImgFreetour2Pt, url: `${this.locale}/assine` };
      } else {
        this.bannerFreeTour2 = { image: this.isMobile ? ImgFreetour2EnMobile : ImgFreetour2En, url: `${this.locale}/assine` };
      }
    },
    BlackIsMobile() {
      return isMobile() ? { height: "150px" } : { height: "225px" };
    },
    WhiteIsMobile() {
      return isMobile()
        ? { height: "230px", top: "400px" }
        : { height: "360px", top: "400px" };
    },
    async getLastModels(changeLanguage = false) {
      if (!sessionStorage.getItem("posts") || changeLanguage)
        api.get("v1/modelos/getLastFiveModels").then(({ data }) => {
          this.posts = data.postsCarroselModels;
          sessionStorage.setItem("posts", JSON.stringify(this.posts));
        });
      else this.posts = JSON.parse(sessionStorage.getItem("posts"));
    },
  },
});
</script>

<style scoped>
.slot-body {
  margin-top: 65px !important;
  background-color: #fff !important;
}
/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  
}
</style>
